import { DonutSt, CircleSt, ArrowSt } from './Donut.css';

interface Props {
  value: number;
  max: number;
}

const Donut = ({ value, max }: Props) => (
  <>
    <DonutSt>
      <CircleSt value={value} max={max} />
    </DonutSt>

    <ArrowSt value={value} max={max} />
  </>
);

export { Donut };
